<template>
<!-- UTILIZADO POR COMPONENTE: MODIFICARPROYECTO.VUE -->
  <div >
    <v-btn small icon @click="modalArchivos = !modalArchivos"><v-icon>mdi-close</v-icon></v-btn>

    <v-dialog v-model="modalArchivos" max-width="600px">
      <v-card>
        <v-card-title>
          ¿Eliminar Archivo?
        </v-card-title>
        <v-card-text class="my-1 font-weight-bold text-subtitle-1 text--primary">
           {{ archivo.NOMBREARCH }}?
        </v-card-text>
        <v-card-actions class="d-flex justify-space-around">
          <v-btn @click="modalArchivos=false" class="grey darken-1" dark>Cancelar</v-btn>
          <v-btn @click="eliminarArchivo" class="red" dark>Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {
	props:['archivo'],
  data() {
    return {
			modalArchivos:false
		};
  },

  computed: {
    ...mapGetters(['getURLAPI'])
  },

	methods: {
		eliminarArchivo(){

      let datosForm = new FormData();
      datosForm.append("PROYECTO_ID",this.archivo.PID);
      
			axios.post(`${this.getURLAPI}/Proyecto/eliminarArchivo/${this.archivo.ARCHIVO_ID}`,datosForm )
      .then( ( {data} ) =>{

        this.$emit('getInformacionProyecto',this.$route.params['id']);

        let ESTATUS = data.STATUS; let MSG = data.MSG;
        this.$root.vtoast.show(
          { message: MSG, color: ESTATUS=='OK' ? 'success darken-2':'red darken-2', 
            timer:10000, icon: ESTATUS=='OK' ? 'mdi-check':'mdi-alert-circle-outline' } 
        )
        
      } )
      .catch( () => {

      } );
		},
	},

	created() {
		console.log(this.archivo);
	},
};
</script>

<style></style>
